import { API } from 'apis';
import { getViaAuth, responseValidator } from 'apis/api';
import { UserBalancePerMarket, UsersBalances } from 'core/domain/wallet/wallet';

export const getAllUsersBalances = async (setLoading: any, setData: any) => {
    setLoading(true);
    await getViaAuth<UsersBalances>(API.wallet.getAllUsersBalances).then((response: any) => {
        setLoading(false);
        if (responseValidator(response.status)) {
            setData(response.value?.assets ?? []);
        }
    });
};

export const getUsersBalanceBySymbol = async (setLoading: any, setData: any, symbol: string) => {
    setLoading(true);
    await getViaAuth<UserBalancePerMarket[]>(`${API.wallet.getUsersBalanceBySymbol}/${symbol}`).then(
        (response: any) => {
            setLoading(false);
            if (responseValidator(response.status)) {
                setData(response.value ?? []);
            }
        },
    );
};
